// ABOUTME: ShDataGrid2 for use inside a modal: renders the grid only once its TabContext and
// ABOUTME: GridFilter instance exists in Redux, so the grid's config reaches its first query.

import { useSelector } from "react-redux";
import { useGridFilter } from "../../../contexts/GridFilterContext";
import ShDataGrid2 from "./ShDataGrid2";

// Renders ShDataGrid2 only once its TabContext/GridFilter instance exists in
// Redux. Without this gate the grid mounts with index=null on the first render,
// latches prevConfigRef, and the config dispatch in ShDataGrid2 never fires.
const GatedShDataGrid2 = (props) => {
    const { index, id } = useGridFilter();
    const instanceReady = useSelector((state) =>
        index !== null && index !== undefined &&
        id !== null && id !== undefined &&
        !!state.gridFilter.viewInstances[index]?.[id]
    );

    if (!instanceReady) return null;
    return <ShDataGrid2 {...props} />;
};

export default GatedShDataGrid2;
